module.exports = "<div class='btn-group' role='group' aria-label=\"{{'Prior Period / Year' | translate}}\">\r\n  <rw-button\r\n    variant=\"{{ $ctrl.year ? 'outlined' : 'contained' }}\"\r\n    action='$ctrl.handleClick(false)'>\r\n    <translate>\r\n      Prior Period\r\n    </translate>\r\n  </rw-button>\r\n  <rw-button\r\n    variant=\"{{ $ctrl.year ? 'contained' : 'outlined' }}\"\r\n    action='$ctrl.handleClick(true)'>\r\n    <translate>\r\n      Prior Year\r\n    </translate>\r\n  </rw-button>\r\n</div>\r\n</div>\r\n\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/rw-prior-period-year/rw-prior-period-year.html
// module id = 2054
// module chunks = 0